import { render } from "./cUpdateNotification.vue?vue&type=template&id=6e32e68c&scoped=true"
import script from "./cUpdateNotification.vue?vue&type=script&lang=js"
export * from "./cUpdateNotification.vue?vue&type=script&lang=js"

import "./cUpdateNotification.vue?vue&type=style&index=0&id=6e32e68c&scoped=true&lang=css"

import exportComponent from "C:\\DevOps\\Internal\\ClockWork.Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e32e68c"]])

export default __exports__